module.exports = __webpack_public_path__ + "img/app-screenshot_3x.4b46dc9c.png";